import ManageAccountPageWrapper from "../../Layout/ManageAccountPageWrapper";
import PageSection from "../../Layout/PageSection";
import { useEffect, useContext, useState } from "react";
import Context from "../../../../context";
import SelectItem from "../../Input/AccountSelectItem";
import DownloadPageSection from "../../Layout/DownloadPageSection";
import {API_URL} from "../../../data/constants";
import axios from "axios";

export default function ManageAccountDownloadDataPage() {
  const { contextState, setContextState } = useContext(Context);
  const [isLoading, setIsLoading] = useState(true);
  let accounts = contextState.downloadAccounts;

    useEffect(() => {
        setIsLoading(true);
        axios
            .get(API_URL + `/Accounts/${localStorage.getItem("username")}`, {
                headers: {
                    Authorization: `${localStorage.getItem("accessToken")}`,
                },
            })
            .then((res) => {
                setContextState({ ...contextState, downloadAccounts: res.data });
                setIsLoading(false);
            })
            .catch((err) => {
                console.error(err);
            });
    }, []);
  
  return (
    <ManageAccountPageWrapper pageName="Download Data">
        {isLoading ? (
            <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border mr-4" role="status"/>
                <h4>Loading Accounts...</h4>
            </div>
        ) : (
          <PageSection sectionName="Select Accounts">
            <ul className="autopay-list">
              {accounts &&
                accounts.map((acct, index) => {
                  return (
                    <SelectItem key={index} account={acct} rowAlign={"normal"} />
                  );
                })}
            </ul>
          </PageSection>
        )}
      <DownloadPageSection accounts={accounts} />
    </ManageAccountPageWrapper>
  );
}
